import isomorphicCookie from "isomorphic-cookie"
import { LOCAL_STORE_PREF } from "../constants"

export function setPref(values) {
  isomorphicCookie.save(
    LOCAL_STORE_PREF,
    JSON.stringify({ ...getPrefs(), ...values }),
    {
      secure: false,
      httpOnly: false
    }
  )
}

export function getPrefs() {
  // Hack / Note setting this in renderOnServer
  const prefs =
    typeof global[LOCAL_STORE_PREF] !== "undefined"
      ? global[LOCAL_STORE_PREF]
      : isomorphicCookie.load(LOCAL_STORE_PREF)
  return prefs || {}
}

export function getPref(name) {
  return getPrefs()[name]
}



// WEBPACK FOOTER //
// ./webapp/scripts/prefs.js